import { AppShell } from '@mantine/core';
import { createAddVoucherModal } from 'features/add-voucher';
import { createBlockVoucherModal } from 'features/block-voucher';
import { createDeleteVoucherModal } from 'features/delete-voucher';
import { createEditVoucherModal } from 'features/edit-voucher';
import { createUnblockVoucherModal } from 'features/unblock-voucher';
import { createVoucherRegistry } from 'entities/voucher';
import { vouchersPageModel } from '../../model';
import cls from './vouchers-page.module.scss';

const VoucherRegistry = createVoucherRegistry(vouchersPageModel.voucherRegistryModel);

const AddVoucherModal = createAddVoucherModal(vouchersPageModel.addVoucherModel);

const EditVoucherModal = createEditVoucherModal(vouchersPageModel.editVoucherModel);

const BlockVoucherModal = createBlockVoucherModal(vouchersPageModel.blockVoucherModel);

const UnblockVoucherModal = createUnblockVoucherModal(vouchersPageModel.unblockVoucherModel);

const DeleteVoucherModal = createDeleteVoucherModal(vouchersPageModel.deleteVoucherModel);

export const VouchersPage = () => (
	<>
		<AppShell.Main className={cls.vouchersPage}>
			<VoucherRegistry
				topBarActionSlot={<AddVoucherModal.Button />}
				tableTdActionSlot={(voucher) => (
					<div className={cls.vouchersPageActions}>
						<EditVoucherModal.ActionIcon
							modalData={voucher}
							disabled={voucher.currentCount < voucher.totalCount}
						/>
						{voucher.isLocked ? (
							<UnblockVoucherModal.ActionIcon modalData={voucher} />
						) : (
							<BlockVoucherModal.ActionIcon modalData={voucher} />
						)}
						<DeleteVoucherModal.ActionIcon
							modalData={voucher}
							disabled={voucher.currentCount < voucher.totalCount}
						/>
					</div>
				)}
				emptyActionSlot={<AddVoucherModal.Button />}
			/>
		</AppShell.Main>
		<AddVoucherModal />
		<EditVoucherModal />
		<BlockVoucherModal />
		<UnblockVoucherModal />
		<DeleteVoucherModal />
	</>
);
